// removed by extract-text-webpack-plugin
module.exports = {"macbook":"_3ovAfC9mHgaMWrEXVht0lT","content":"_3D8hFeGBsApZm9rfFFgec6"};


//////////////////
// WEBPACK FOOTER
// ../components/macbook/styles.module.css
// module id = 603
// module chunks = 0